// Auto-gift dismissal state, shared with AutoGiftHandler (snippets/cart-drawer.liquid)
// through sessionStorage: keeps the gift removed for the session while the cart stays eligible.
const AUTO_GIFT_DISMISSED_KEY = 'AUTO_GIFT_DISMISSED';

function getDismissedAutoGifts() {
  try {
    return JSON.parse(sessionStorage.getItem(AUTO_GIFT_DISMISSED_KEY) || '[]');
  } catch (error) {
    return [];
  }
}

function dismissAutoGift(productId) {
  const id = Number(productId);
  if (!id) return;
  const dismissed = getDismissedAutoGifts();
  if (!dismissed.includes(id)) {
    dismissed.push(id);
    try {
      sessionStorage.setItem(AUTO_GIFT_DISMISSED_KEY, JSON.stringify(dismissed));
    } catch (error) {}
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');
      // Auto gifts: remember the manual dismissal so AutoGiftHandler won't re-add
      // the gift while the cart is still eligible.
      if (this.dataset.autoGiftId) {
        dismissAutoGift(this.dataset.autoGiftId);
      }
      cartItems.updateQuantity(
        this.dataset.index,
        0,
        undefined,
        this.dataset.lineKey
      );
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

function showCartItemError(line, message) {
  document
    .querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
    .forEach(error => {
      error.textContent = message;
    });
}

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.progress = this.getAttribute('data-progress');
  }

  connectedCallback() {
    setTimeout(() => {
      this.querySelector('[data-progress-line]').style.width = this.progress;
    }, 100);
  }
}
customElements.define('progress-bar', ProgressBar);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change',
      this.debouncedOnChange.bind(this)
    );

    updateFreeShipping();
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return [
      {
        id: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        }`,
        section:
          document.getElementById('main-cart-items').dataset.id,
        selector: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        } cart-items`
      },
      {
        id: '#cart-counter',
        section: 'cart-counter',
        selector: '#shopify-section-cart-counter'
      }
    ];
  }

  updateQuantity(line, quantity, name, lineKey) {
		console.log("updateQuantity");
    this.classList.add('is-loading');

    const body = JSON.stringify({
      ...(lineKey ? { id: lineKey } : { line }),
      quantity,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            section.id === '#cart-counter'
              ? document.querySelector(section.id)
              : document.querySelector(section.selector);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
				
        this.updateLiveRegions(line, parsedState.item_count, quantity);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        updateFreeShipping();
      })
      .catch(() => {
        showCartItemError(
          line,
          'Não foi possível atualizar este item. Tente novamente.'
        );
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount, quantity) {
    // Only surface the "you can only add X" limit message on a real quantity
    // increase that got clamped — never on removals (quantity 0) or background
    // re-renders, which would otherwise show a false positive on the wrong line.
    if (quantity !== 0 && this.currentItemCount === itemCount) {
      document
        .querySelectorAll(
          `[data-line-item-error][data-line="${line}"]`
        )
        .forEach(error => {
          error.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.querySelector(`[id*="ProductQuantity-${line}"]`)
              .value
          );
        });
    }

    this.currentItemCount = itemCount;
  }
}

customElements.define('cart-items', CartItems);
